export default "__VITE_ASSET__C86C$wUn__ 640w, __VITE_ASSET__mmF$KPHI__ 1024w, __VITE_ASSET__BJ8Wg7wA__ 1536w";